import { browser } from '$app/environment';
import { FlowAPI } from '$lib/interfaces/interfaces';
import { PUBLIC_API_URL } from '$env/static/public';
import { getCookie } from '$lib/helpers/session';

let cookie: string | undefined;
let impersonationCookie: string | undefined;

if (browser) {
  const cookies = document.cookie.split('; ');
  cookie = cookies.find((str) => /^token=/.test(str));

  impersonationCookie = cookies.find((str) => /^impersonation_token=/.test(str));
}

const securityWorker = async () => {
  let headers = {};

  if (cookie) {
    const token = getCookie('token');
    headers = { ...headers, Authorization: `Bearer: ${token}` };
  }

  if (impersonationCookie) {
    const token = impersonationCookie.replace('impersonation_token=', '');
    headers = { ...headers, 'Impersonation-Token': token };
  }

  return { headers };
};

export const flowApi = new FlowAPI({ baseUrl: PUBLIC_API_URL, securityWorker });
